module.exports = __webpack_public_path__ + "img/master.17398b4e.jpg";